import { render, staticRenderFns } from "./ConfigSimulacionMoldes.vue?vue&type=template&id=769f928f&scoped=true&"
import script from "./ConfigSimulacionMoldes.vue?vue&type=script&lang=js&"
export * from "./ConfigSimulacionMoldes.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSimulacionMoldes.vue?vue&type=style&index=0&id=769f928f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f928f",
  null
  
)

export default component.exports